import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { fetchCategory, createCategory, deleteCategory, updateCategory, updateCatDisabled } from '../../common/jsonstore';
import { Category } from '../../common/model';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
  CategoryArr: Category[];
  success: any;
  isProcessingComplete: boolean;
}

const initialState: IAuthentication = { CategoryArr: [], success: {}, isProcessingComplete: false };
// const initialState: Category[] = [];

const CategorySlice = createSlice({
  name: 'Category',
  initialState,
  reducers: {
    receiveUsers(state, action: PayloadAction<Category[]>) {
      return {
        ...state,
        CategoryArr: action.payload,
        isProcessingComplete: false
      };
      // return action.payload;
    },
    receiveUser(state, action: PayloadAction<any>) {
      // state.push(action.payload);
      return {
        ...state,
        CategoryArr: action.payload,
        isProcessingComplete: false
      };
    },
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});


// const { messageApi } = React.useContext(CommonContext) as CommonContextType;

export const loadCategory = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const Category = await fetchCategory().then((res: any) => {
      dispatch(CategorySlice.actions.receiveUsers(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Category not loaded';
        handleError(msg);
      }
    });
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addCategogy = (newCat: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await createCategory(newCat).then((resp: any) => {
      // dispatch(CategorySlice.actions.receiveUser([...getState().Category.CategoryArr, resp?.data]));
      dispatch(CategorySlice.actions.receiveUsers(resp?.data))
      dispatch(CategorySlice.actions.success({ 'sts': true, data: resp?.msg }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Category Not Added';
        dispatch(CategorySlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyCategory = (newCat: any, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await updateCategory(newCat, id).then((resp: any) => {
      // const updatedUsers = getState().Category.CategoryArr.map(el => (el.id === id ? resp?.data : el))
      // dispatch(CategorySlice.actions.receiveUsers(updatedUsers));
      dispatch(CategorySlice.actions.receiveUsers(resp?.data))
      dispatch(CategorySlice.actions.success({ 'sts': true, data: 'Category updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Category Not Updated';
        dispatch(CategorySlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyCatDisabled = (newCat: any, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res: any = await updateCatDisabled(newCat, id).then((resp: any) => {
      // const updatedUsers = getState().Category.CategoryArr.map(el => (el.id === id ? resp?.data : el))
      // dispatch(CategorySlice.actions.receiveUsers(updatedUsers));
      dispatch(CategorySlice.actions.receiveUsers(resp?.data))
      dispatch(CategorySlice.actions.success({ 'sts': true, data: 'Category updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Category Not Updated';
        dispatch(CategorySlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeCategory = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    await deleteCategory(id).then((res:any) => {
      // const updatedUsers = getState().Category.CategoryArr.filter((item) => item.id !== id);
      // dispatch(CategorySlice.actions.receiveUsers(updatedUsers));
      dispatch(CategorySlice.actions.receiveUsers(res?.data))
      dispatch(CategorySlice.actions.success({ 'sts': true, data: 'Category deleted Successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      }
      else {
        let msg = ''
        if (err?.response?.data?.data?.constraint?.includes("FK")) {
          msg = 'Category not deleted,It is being used in body shape'
        } else {
          msg = err?.response?.data?.msg
        }
        dispatch(CategorySlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(CategorySlice.actions.success(data));
}

export default CategorySlice.reducer;
